
const lastUpdate = '2026-03-15';
export const helpTitle = 'Values at Risk Explorer';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Values at Risk (VAR) Explorer shows infrastructure and assets that may be threatened by wildfire — communities, facilities, cultural sites, and other significant locations.</p>

<h2>Browsing VAR Records</h2>
<ul>
  <li>Records are listed in a grid. Click any record to open its detail panel.</li>
  <li>Use <strong>Filter</strong> to narrow by category, region, or status.</li>
</ul>

<h2>Actions from the Map Popup</h2>
<p>Click a VAR feature on the map to open its popup, which provides quick actions:</p>
<ul>
  <li><strong>Red Flag</strong> — Mark this asset as red-flagged for priority attention.</li>
  <li><strong>Sprinkler Activation</strong> — Record that sprinkler systems have been activated.</li>
  <li><strong>View on Map</strong> — Zooms the map to the asset's location.</li>
</ul>

<h2>Tips</h2>
<ul>
  <li>Use the <strong>Category</strong> filter to focus on a specific asset type (e.g., communities, infrastructure).</li>
  <li>The <strong>Status</strong> filter lets you quickly find assets that are red-flagged or have active sprinkler systems.</li>
</ul>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
